/**
 * @file NoList Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'no-list',
  (data) => `
<svg width="${data.size}" height="${data.size}" viewBox="0 0 48 48">
  <g
    fill="none"
    fill-rule="evenodd"
    stroke="none"
    stroke-width="${data.strokeWidth * 0.15}"
    opacity="0.200000003"
  >
    <g fill="#000000" fill-rule="nonzero" transform="translate(-192,-109.8)">
      <g transform="translate(190.79999999999998,109.8)">
        <g transform="translate(1.2,0)">
          <path
            d="M8.00769 2.4 35.01803 2.4 39.31145 8.03228 43.5 13.36792 43.5 41.23636C43.5 45.63456 43.85504 46.2 40.59231 46.2L8.00769 46.2C4.74496 46.2 5.1 45.63456 5.1 41.23636L5.1 7.36364C5.1 2.96544 4.74496 2.4 8.00769 2.4ZM34.5 4.2 34.5 13.2 41.7 13.2 34.5 4.2ZM12.29577 18.6 31.50423 18.6C32.16464 18.6 32.7 17.92843 32.7 17.1 32.7 16.27157 32.16464 15.6 31.50423 15.6L12.29577 15.6C11.63536 15.6 11.1 16.27157 11.1 17.1 11.1 17.92843 11.63536 18.6 12.29577 18.6ZM12.28697 27 27.31303 27C27.73707 27.00009 28.12893 26.71421 28.34097 26.25007 28.55301 25.78593 28.55301 25.21407 28.34097 24.74993 28.12893 24.28579 27.73707 23.99991 27.31303 24L12.28697 24C11.86293 23.99991 11.47107 24.28579 11.25903 24.74993 11.04699 25.21407 11.04699 25.78593 11.25903 26.25007 11.47107 26.71421 11.86293 27.00009 12.28697 27ZM12.28697 34.8 27.31303 34.8C27.73707 34.80009 28.12893 34.51421 28.34097 34.05007 28.55301 33.58593 28.55301 33.01407 28.34097 32.54993 28.12893 32.08579 27.73707 31.79991 27.31303 31.8L12.28697 31.8C11.86293 31.79991 11.47107 32.08579 11.25903 32.54993 11.04699 33.01407 11.04699 33.58593 11.25903 34.05007 11.47107 34.51421 11.86293 34.80009 12.28697 34.8ZM39.0705 25.2C36.3345 27.40429 34.35 30.18772 33.4545 31.58239L31.2675 29.33082 30.3 30.35319 34.0755 35.4C34.7235 33.21344 36.7845 28.94079 39.3 25.90324L39.0705 25.2 39.0705 25.2Z"
          />
        </g>
      </g>
    </g>
  </g>
</svg>
`
);
